import React from "react";
import { match } from "react-router";
import { Paper } from "src/components";
import { MatchParams } from "src/routes";
import { useTranslation } from "react-i18next";
import { theme } from "src/config";
export interface IFaqProps {
  match: match<MatchParams>; // This is injected so it has to be called match
}

export const Faq = (props: IFaqProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    return <Paper style={theme.paper.regular} />;
}
